'use client';

import React from "react";

const GradientWrapper = ({ children, className = "", innerClassName = "" }) => (
  <div className={`rounded-lg bg-gradient-to-b from-[#3e3e3e] to-[#5c5c5c4d] p-[1px] w-full ${className}`}>
    <div className={`bg-transparent bg-gradient-to-b from-[#1C1C1C] to-[#131517] rounded-md h-full w-full ${innerClassName}`}>
      {children}
    </div>
  </div>
);

export default GradientWrapper;
